import React, { Component } from 'react'
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import 'filepond/dist/filepond.min.css'
import './FileUploader.module.css'
import { validFileExtensions } from '../../strings/fileExtensions'
import { deleteDocument, postDocument } from '../../utilities'

registerPlugin(FilePondPluginFileValidateSize)

export class FileUploader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      files: []
    }

    this.deleteUploadedDocument = this.deleteUploadedDocument.bind(this)
    this.postUploadedDocument = this.postUploadedDocument.bind(this)
  }

  componentDidMount() {
    this.setState({
      files: this.props.documents.map(doc => ({
        source: doc.document,
        options: { type: 'limbo', file: doc.file }
      }))
    })
  }

  addDocument(newDoc) {
    const docs = this.props.documents.concat(newDoc)
    this.props.handleChangeValue(this.props.name, docs)
  }

  removeDocument(id) {
    const docs = this.props.documents.filter(obj => obj.document != id)
    this.props.handleChangeValue(this.props.name, docs)
  }

  deleteUploadedDocument(id, load, error) {
    deleteDocument(id, this.getToken(id))
      .then(() => {
        load()
        this.removeDocument(id)
      })
      .catch(err => {
        error(err)
      })
  }

  postUploadedDocument(file, load, error, abort) {
    if (!this.validateFileName(file.name)) {
      error('filename')
    } else if (!this.validateDocumentType(file.name)) {
      error('extension')
    } else {
      const formData = new FormData()
      formData.append('document', file, file.name)
      formData.append('filename', file.name)

      postDocument(formData)
        .then(resp => {
          load(resp.id)
          this.addDocument({
            file,
            document: resp.id,
            token: resp.token
          })
        })
        .catch(err => {
          error(err)
        })
    }

    return {
      abort: () => {
        // This function is entered if the user has tapped the cancel button
        // request.abort()

        // Let FilePond know the request has been cancelled
        abort()
      }
    }
  }

  getToken(id) {
    const doc = this.props.documents.find(obj => obj.document == id)
    return doc.token
  }

  validateDocumentType(fileName) {
    const fileExtension = fileName.replace(/^.*\./, '')
    return validFileExtensions.includes(fileExtension.toLowerCase())
  }

  validateFileName(fileName) {
    // Return boolean. filename contains non-keyboard characters
    const regex = /[^\u0020-\u007E]/
    return !regex.test(fileName)
  }

  render() {
    const server = {
      process: (fieldName, file, metadata, load, error, progress, abort) => {
        this.postUploadedDocument(file, load, error, abort)
      },
      revert: (uniqueFileId, load, error) => {
        this.deleteUploadedDocument(uniqueFileId, load, error)
      }
    }

    const errorMessage = errorWord => {
      const defaultMsg = 'Error during upload'
      let messages = {
        extension: 'This file does not use an acceptable file extension',
        filename: 'File name has invalid characters'
      }
      return messages[errorWord] ? messages[errorWord] : defaultMsg
    }

    return (
      <FilePond
        ref={ref => (this.pond = ref)}
        files={this.state.files}
        allowMultiple={true}
        maxFileSize="50MB"
        labelIdle="<div class='ds-u-padding-top--2'>Drag and drop your files, or <span class='filepond--label-action'> browse</span></div>
        <div class='ds-u-padding-top--2'>Allowed extensions: csv, doc, docx, gif, jpg, jpeg, pdf, png, tif, tiff, txt, xls, xlsx</div>
        <div class='ds-u-padding-bottom--2'>Maximum size: 50MB per file</div>"
        labelMaxFileSize="Files must not exceed {filesize}"
        labelFileProcessingError={error => errorMessage(error.body)}
        server={server}
        onupdatefiles={fileItems => {
          // Set currently active file objects to this.state
          this.setState({
            files: fileItems.map(fileItem => fileItem.file)
          })
        }}
      />
    )
  }
}
